import './scss/styles.scss';
import Swiper from 'swiper';
import baguetteBox from 'baguettebox.js';

import {MDCTopAppBar} from '@material/top-app-bar';
import {MDCRipple} from '@material/ripple';
import {MDCSwitch} from '@material/switch'
import {MDCLineRipple} from '@material/line-ripple';
import {MDCList} from '@material/list';
import {MDCMenuSurface} from '@material/menu-surface';
import {MDCMenu} from '@material/menu';

window.onload = () => {

    let ThemeScript = {};

    const menuBtn = document.getElementById("topAppButton");

    /**
     * Body element
     * @type {HTMLElement}
     */

    const body = document.body;

    /**
     * Dropdown element
     * @type {HTMLElement}
     */
    const menuDrop = document.getElementById('collapseMenu');

    /**
     * List of available menus
     * @type {HTMLCollectionOf<Element>}
     */
    const menuList = document.querySelectorAll('.ac-header__nav .menu-item-has-children');

    /**
     * get Top app bar
     * @type {Element}
     */
    const mdcTopAppBar = document.getElementById('topAppBar');

    ThemeScript = {
        construct: function () {
            ThemeScript.materialConfig();
            ThemeScript.checkDocumentScrollPosition();
            ThemeScript.headerInteractiveOnScroll();
            ThemeScript.expandMenu();
            ThemeScript.expandSubMenu();
            ThemeScript.homeSlider();
            ThemeScript.doctorsSlider();
            ThemeScript.dropdownAction();
        },
        isMobile: () => {
            return window.screen.width < 992;
        },
        materialConfig() {
            const mdcButton = document.querySelectorAll('.mdc-button');
            const mdcSwitchControl = document.querySelectorAll('.mdc-switch');
            const mdcLineRipple = document.querySelector('.mdc-line-ripple');
            const mdcList = document.querySelector('.mdc-list');
            const mdcMenuSurface = document.querySelectorAll('.mdc-menu-surface');
            const mdcMenu = document.querySelectorAll('.mdc-menu');

            if (mdcButton) {
                Array.prototype.forEach.call(mdcButton, (item) => {
                    let ripple = new MDCRipple(item);
                });
            }
            if (mdcSwitchControl.length > 0) {
                Array.prototype.forEach.call(mdcSwitchControl, (item) => {
                    let switchControl = new MDCSwitch(item);
                });
            }
            if (mdcLineRipple) {
                const lineRipple = new MDCLineRipple(mdcLineRipple);
            }
            if (mdcTopAppBar) {
                const topAppBar = new MDCTopAppBar(mdcTopAppBar);
            }
            if (mdcList) {
                let list = new MDCList(mdcList);
                const listItemRipples = list.listElements.map((mdcList) => new MDCRipple(mdcList));
            }
            if (mdcMenuSurface.length > 0) {
                Array.prototype.forEach.call(mdcMenuSurface, (item) => {
                    let menuSurface = new MDCMenuSurface(item);
                });
            }
            if (mdcMenu.length > 0) {
                Array.prototype.forEach.call(mdcMenuSurface, (item) => {
                    let menu = new MDCMenu(item);
                });
            }
        },
        checkDocumentScrollPosition: () => {
            if (window.scrollY === 0) {
                mdcTopAppBar.classList.add('ac-header--on-top');
            } else {
                mdcTopAppBar.classList.remove('ac-header--on-top');
            }
        },
        headerInteractiveOnScroll: () => {
            document.addEventListener('scroll', () => {
                ThemeScript.checkDocumentScrollPosition();
            }, false);
        },
        expandMenu: () => {
            if (menuBtn) {
                menuBtn.onclick = () => {
                    ThemeScript.toggleMenu();
                };
            }
        }, // Menu Toggle - Hides page while mobile menu is open. (Chris)
        toggleMenu() {
            body.style.overflow = body.style.overflow === 'hidden' ? 'initial' : 'hidden';
            body.style.position = body.style.position === 'fixed' ? 'initial' : 'fixed';
            mdcTopAppBar.classList.toggle('ac-header--nav-open');
        },
        expandSubMenu: () => {
            if (menuList.length > 0) {
                console.log(menuList);
                Array.prototype.forEach.call(menuList, (item, index) => {
                    item.addEventListener('click', () => {
                        Array.prototype.forEach.call(menuList, (newItem, newIndex) => {
                            if (newItem.classList.contains('menu-item--open') && newIndex !== index) {
                                newItem.classList.remove('menu-item--open');
                            }
                        });

                        item.classList.toggle('menu-item--open');
                    })
                })
            }
        },
        homeSlider() {
            const homeSlider = new Swiper('.main-section__slider', {
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: '.main-section__slider .ac-swiper__button-next',
                },
                pagination: {
                    el: '.main-section__slider .swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    680: {
                        slidesPerView: 1,
                    }
                }
            });
        },
        doctorsSlider: () => {
            const doctorsContainer = document.querySelector('.ac-doctors__container');
            if (ThemeScript.isMobile() && doctorsContainer) {
                doctorsContainer.classList.add('swiper-container');

                const doctorSlider = new Swiper('.ac-doctors__container', {
                    slidesPerView: 3,
                    spaceBetween: 8,
                    loop: true,
                    navigation: {
                        nextEl: '.ac-doctors__swiper-actions .ac-swiper__button-next',
                        prevEl: '.ac-doctors__swiper-actions .ac-swiper__button-prev',
                    },
                    breakpoints: {
                        680: {
                            loop: true,
                            centeredSlides: true,
                            slidesPerView: 1.3,
                            spaceBetween: 8,
                        }
                    }
                });
            }
        },
        dropdownAction() {
            const btnCollapse = document.getElementById('filterMenu');

            if (btnCollapse && menuDrop) {
                btnCollapse.addEventListener('click', (e) => {
                    ThemeScript.expandDropdown();
                    e.stopPropagation();
                });
                body.addEventListener('click', () => {
                    if (!menuDrop.classList.contains('menu__collapse--collapsed')) {
                        ThemeScript.expandDropdown();
                    }
                });
            }
        },
        expandDropdown() {
            menuDrop.classList.toggle('menu__collapse--collapsed');
            body.classList.toggle('menu-collapse-is-open');
        },
    };

    ThemeScript.construct();
};


/**
 *
 * @type {NodeListOf<Element>}
 */
const tabLinks = document.querySelectorAll('.ac-office-tour__link');
const galleries = document.querySelectorAll('.ac-office-tour__content');

let ThemeScriptInstant = {};

ThemeScriptInstant = {
    construct: function () {
        ThemeScriptInstant.runGallery();
        ThemeScriptInstant.changeGallery();

    },

    runGallery: () => {
        baguetteBox.run('.ac-office-tour__gallery');
    },
    changeGallery: () => {
        Array.prototype.forEach.call(tabLinks, (item) => {
            item.addEventListener('click', () => {
                if (!item.classList.contains('ac-office-tour__link--active')) {
                    ThemeScriptInstant.removeTabLinksClasses();
                    item.classList.add('ac-office-tour__link--active');

                    ThemeScriptInstant.hideGalleries();
                    const currentGallery = document.getElementById(item.dataset.event);
                    currentGallery.style.display = 'block';
                }
            });
        });
    },
    hideGalleries: () => {
        Array.prototype.forEach.call(galleries, item => {
            item.style.display = 'none';
        });
    },
    removeTabLinksClasses: () => {
        Array.prototype.forEach.call(tabLinks, (item) => {
            item.classList.remove('ac-office-tour__link--active')
        });
    },
};

ThemeScriptInstant.construct();


